$(document).ready(function() {
    //bootstrap multiple modal bugfix
    $('.modal').on('shown.bs.modal', function() {
        $('body').addClass('modal-open');
    });
    $('.siteworks select').SumoSelect({
        search: true,
        searchText: 'Search for...'
    });

    $('.view-details').on('click', function(e) {
        e.preventDefault();
        $('#terms-modal')
            .data('url', $(this).attr('href'))
            .modal('show');
    });

    $('#terms-modal-accept').on('click', function(e) {
        e.preventDefault();
        $('#terms-modal').modal('hide');

        $.ajax({
            url: $('#terms-modal').data('url'),
            method: 'GET',
            dataType: 'html'
        }).done(function(response) {
            $('#details-modal-body').html(response);
            $('#details-modal').modal('show');
        });
    });
});
